import {
  setSidebarClose_actionType,
  setSidebarOpen_actionType,
  setSidebarToggle_actionType,
} from "../constants";

export const openSidebar = () => ({
  type: setSidebarOpen_actionType,
});

export const closeSidebar = () => ({
  type: setSidebarClose_actionType,
});

export const toggleSidebar = () => ({
  type: setSidebarToggle_actionType,
});
